import { render, staticRenderFns } from "./flights.vue?vue&type=template&id=f01325f8&"
import script from "./flights.vue?vue&type=script&lang=js&"
export * from "./flights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports